import React, { useMemo, useState, useEffect } from 'react';
import { AppBar, Box, IconButton, SwipeableDrawer, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CachedIcon from '@mui/icons-material/Cached';
import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import MenuList from './MenuList';
import logo from '../../assets/images/placeholder/logo.png';
import AppConst from './const';
import LogoutDialog from '../LogoutDialog';
import { menuItems, adminMenuItems } from './menuItems';
import CWPPlotModal from '../Reports/CWPPlotModal';
import PurchaseOrderReportModal from '../Reports/PurchaseOrderReportModal';
import DCRModal from '../Reports/DCRModal';
import PresentationLogModal from '../Reports/PresentationLogModal';
import WeeklyProductReportModal from '../Reports/WeeklyProductReportModal';
import CallVolumeVsProductUsageReportModal from '../Reports/CallVolumeVsProductUsageReportModal';
import ProductUtilModal from '../Reports/ProductUtilModal';
import ProductSamplingReportModal from '../Reports/ProductSamplingReportModal';
import ProductSamplingInventoryModal from '../Reports/ProductSamplingInventoryModal';
import LocationTrackerLogModal from '../Reports/LocationTrackerLogModal';
import ClientCallOutExtractorModal from '../Reports/ClientCallOutExtractorModal';
import AdminTaggedAccounts from '../AdminTaggedAccounts';
import ProductPresentationModal from '../Reports/ProductPresentationModal';
import MDTicketExport from '../Reports/MDTicketExport';
import ProductUtil6psModal from '../Reports/ProductUtil6psModal';
import MaterialsUtilization from '../Reports/MaterialsUtilization';

function AppLayout({ children }) {
  const { pathname } = useLocation();

  const { AppContext } = AppConst;

  const [title, setTitle] = useState('SFE CRM (Manager)');
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [toggleLogout, setToggleLogout] = useState(false);
  const [toggleModal, setToggleModal] = useState(null);

  useEffect(() => {
    // build flat array from menuItems
    const currentUrl = pathname.substr(1); // remove lead slash

    const selected = _.chain([...menuItems, ...adminMenuItems])
      .map((row) => {
        if (row?.child) {
          return row?.child.map((rChild) => ({ url: rChild.url, title: rChild.title }));
        }

        return { url: row.url, title: row.title };
      })
      .flatten()
      .find((row) => row.url === currentUrl)
      .value();

    setTitle(selected?.title ?? `SFE CRM (Manager)`);
  }, [pathname]);

  const onSetTitle = (overrideTitle) => {
    setTimeout(() => {
      setTitle(overrideTitle);
    }, 100);
  };

  const onToggleModal = (row) => {
    setToggleModal(row);
  };

  const appContextProvider = useMemo(
    () => ({
      toggleLogout,
      toggleModal,
      setToggleLogout,
      onToggleModal,
      onSetTitle,
    }),
    [toggleLogout, setToggleLogout, onSetTitle, toggleModal, setToggleModal],
  );

  const handleOpenDrawer = () => setToggleDrawer(true);
  const handleCloseDrawer = () => {
    setToggleDrawer(false);
  };

  // const handleChangePage = (row) => {
  //   setToggleDrawer(false);

  //   // trigger change page after drawer hide
  //   if (row?.type === 'modal') return;

  //   setTimeout(() => {
  //     navigate(row.url);
  //   }, 350);
  // };

  useEffect(() => {
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon) {
      favicon.href = logo;
    }
    document.title = 'BK CRM Web Portal';
  }, []);

  return (
    <AppContext.Provider value={appContextProvider}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <AppBar position='static' sx={{ backgroundColor: '#6B8D3E' }}>
          <Toolbar variant='dense'>
            <IconButton
              edge='start'
              color='inherit'
              aria-label='menu'
              sx={{ mr: 2 }}
              onClick={handleOpenDrawer}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant='h6' component='div' sx={{ flexGrow: 1, textAlign: 'center' }}>
              {title}
            </Typography>
            <IconButton edge='end' color='inherit' aria-label='menu' sx={{ ml: 2 }}>
              <CachedIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Box>{children}</Box>
        <SwipeableDrawer
          anchor='left'
          open={toggleDrawer}
          onClose={handleCloseDrawer}
          onOpen={handleOpenDrawer}
        >
          <MenuList toggleDrawer={handleCloseDrawer} /> {/* TOGGELE DRAWWER */}
        </SwipeableDrawer>

        <LogoutDialog />

        <CWPPlotModal />
        <PurchaseOrderReportModal />
        <DCRModal />
        <PresentationLogModal />
        <WeeklyProductReportModal />
        <CallVolumeVsProductUsageReportModal />
        <ProductUtilModal />
        <ProductSamplingReportModal />
        <ProductSamplingInventoryModal />
        <LocationTrackerLogModal />
        <ClientCallOutExtractorModal />
        <AdminTaggedAccounts />
        <ProductPresentationModal />
        <MDTicketExport />
        <ProductUtil6psModal />
        <MaterialsUtilization />
      </LocalizationProvider>
    </AppContext.Provider>
  );
}

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppLayout;
